import { createAPI } from '@/request.js'

// 登录
export const login = data => createAPI('/api/manage/user/login.mt', 'post', data)
// 登出
export const logout = data => createAPI('/api/manage/user/logout.mt', 'post', data)
// 修改个人信息
export const userInfo = data => createAPI('/api/manage/user/info/modify.mt', 'post', data)
// 修改密码
export const password = data => createAPI('/api/manage/user/password/modify.mt', 'post', data)
// 获取菜单
export const menuQuery = data => createAPI('/api/manage/user/menu/query.mt', 'post', data)
